module.exports = __webpack_public_path__ + "img/image-nutrition.999d281e.jpg";